// Service radius the vendor covers, in kilometres. Bounds must stay in sync
// with the server-side validation in evChargerService/index.resolver.ts.
export const MIN_AREA_SERVICED_KM = 1;
export const MAX_AREA_SERVICED_KM = 500;
export const AREA_SERVICED_STEP_KM = 5;
export const DEFAULT_AREA_SERVICED_KM = 200;
